<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <div class="col-12 text-center text-sm-left mb-0">
        <span class="text-uppercase page-subtitle d-block">Lista</span>
        <h3 class="page-title d-inline">Jogos</h3>
        <router-link class="btn btn-success text-white float-right " :to="{ name: 'admin-puzzle-new' }">Novo jogo</router-link>
      </div>
    </d-row>

    <!-- Default Light Table -->
    <d-row>
      <d-col>
        <d-card class="card-small mb-4">
          <div class="card-header border-bottom d-flex justify-content-around">
            <d-col cols="12" md="4">
              <h6 class="m-0">Jogos Ativos</h6>
            </d-col>
            <d-col cols="12" md="8">
              <form class="main-sidebar__search">
                <d-form-row>
                  <d-col cols="2">
                    <d-select v-model="pagination.status_id" @change="resetPagination">
                      <option :value="null">Filtro por status</option>
                      <option :value="status.id" v-for="status in statuses" :key="status.id">{{ status.name }}</option>
                    </d-select>
                  </d-col>
                  <d-col cols="2">
                    <d-select v-model="pagination.cat_id" @change="resetPagination">
                      <option :value="null">Grátis ou não</option>
                      <option :value="1">Só Grátis</option>
                    </d-select>
                  </d-col>
                  <d-col cols="2">
                    <d-select v-model="pagination.type_id" @change="resetPagination">
                      <option :value="null">Filtro por tipo</option>
                      <option :value="type.id" v-for="type in types" :key="type.id">{{ type.name }}</option>
                    </d-select>
                  </d-col>
                  <d-col cols="6">
                    <div class="input-group input-group-seamless ml-3">
                      <div class="input-group-prepend">
                        <div class="input-group-text">
                          <i class="fas fa-search"></i>
                        </div>
                      </div>
                      <input
                        class="navbar-search form-control"
                        type="text"
                        placeholder="Procurar por algo..."
                        aria-label="Search"
                        v-model="pagination.search"
                      >
                    </div>
                  </d-col>
                </d-form-row>
              </form>
            </d-col>
          </div>
          <div class="card-body p-0 pb-3 text-left">
            <div class="table-overflow">
              <puzzle-table :puzzles="puzzles.list" />
            </div>
            <pagination :total-items="puzzles.total_items" :pagination.sync="pagination"></pagination>
          </div>
        </d-card>
      </d-col>
    </d-row>
  </d-container>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import Pagination from '_shared/Pagination.vue';
import PuzzleTable from '../components/PuzzleListTable.vue';

export default {
  name: 'puzzle-list',
  components: {
    Pagination,
    PuzzleTable,
  },
  data() {
    return {
      pagination: {
        search: '',
        status_id: null,
        cat_id: null,
        type_id: null,
        skip: (this.$route.params.page - 1) * 10,
        take: 10,
        page: parseInt(this.$route.params.page, Number),
      },
    };
  },
  computed: {
    types() {
      const { types } = this.$store.state.puzzle;
      if (types.length) {
        return types;
      }
      return [];
    },
    statuses() {
      const { status } = this.$store.state.puzzle;
      if (status.length) {
        return status;
      }
      return [];
    },
    puzzles() {
      const { puzzleList } = this.$store.state.puzzle;
      if (puzzleList && puzzleList.list.length) {
        return puzzleList;
      }
      return {
        list: [],
        total_items: 0,
      };
    },
  },
  methods: {
    ...mapActions([
      'setToggle',
      'getTypesList',
      'getStatusList',
      'getPuzzleList',
    ]),
    getList() {
      this.getPuzzleList(this.pagination);
    },
    getOptions() {
      if (this.types.length === 0) {
        this.getTypesList();
      }
      if (this.statuses.length === 0) {
        this.getStatusList();
      }
    },
    resetPagination() {
      this.pagination.page = 1;
      this.pagination.skip = 0;
    },
  },
  destroyed() {
    Events.$off('update:pagination');
  },
  mounted() {
    this.getOptions();
    Events.$emit('sidebarVisible', false);
    Events.$on('update:pagination', pagination => {
      this.$router.push({ params: { page: pagination.page } });
      this.getList();
    });
    this.getList();
  },
};
</script>

<style lang="scss" scoped>
</style>
